import React from 'react';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Card, { CardHeader, CardMedia, CardContent, CardActions } from 'material-ui/Card';
import Collapse from 'material-ui/transitions/Collapse';
import red from 'material-ui/colors/red';
import FavoriteIcon from 'material-ui-icons/Favorite';
import IconButton from 'material-ui/IconButton';

const styles = theme => ({
  card: {
    maxWidth: '45%',
    margin: 5,
    float: 'left',
  },
  media: {
    height: 194,
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
  flexGrow: {
    flex: '1 1 auto',
  },
});


class SearchResultsItemCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleListItemClick(url) {
    var win = window.open(url, '_blank');
    win.focus();
  }

  componentDidMount() {
  }

  render() {
    const classes = this.props.classes;
    const img = (this.props.item.pagemap && this.props.item.pagemap.cse_thumbnail) ? this.props.item.pagemap.cse_thumbnail[0].src : 'http://via.placeholder.com/350x150';
    return (
      <Card className={classes.card}>
        <CardHeader title={this.props.item.title} subheader={this.props.item.date}/>
        <CardMedia className={classes.media} image={img}/>
        <CardContent>{this.props.item.snippet}</CardContent>
        <CardActions disableActionSpacing>
          <IconButton aria-label="Add to favorites" onClick={() => this.handleListItemClick(this.props.item.link)}><FavoriteIcon /></IconButton>
          <div/>
        </CardActions>
        <Collapse transitionDuration="auto" unmountOnExit>
          <CardContent><Typography paragraph type="body2">{this.props.item.meta}</Typography></CardContent>
        </Collapse>
      </Card>
    );
  }


}

export default withStyles(styles)(SearchResultsItemCard);


// WEBPACK FOOTER //
// ./src/search/search_results_item_card.js